import React from 'react';
import { shape, bool, arrayOf, string, func } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { operations } from 'state/ducks/map';
import { replace } from 'react-router-redux';
import LoadingIndicator from 'components/LoadingIndicator';

import locationShape from 'propTypes/locationShape';
import sortRoutes from 'helpers/sortRoutes';

import List from '../List';
import ListLabels from '../ListLabels';
import ListItem from '../ListItem';
import RoutesListItem from '../RoutesListItem';
import Sorting from '../Sorting';
import EmptyPanelState from '../EmptyPanelState';

const RoutesQuery = gql`
  query Routes {
    routes {
      id
      status
      from {
        id
        name
      }
      to {
        id
        name
      }
      expectedTravelTime
      speedLastHour
      liveSpeed
      travelTimeIndex
      segments {
        id
        status
        path
        liveTravelTime
        expectedTravelTime
        speedLastHour
        liveSpeed
      }
    }
  }
`;

export function Routes({
  data,
  currentHover,
  selectEntity,
  enterEntity,
  leaveEntity,
  location,
  historyReplace,
}) {
  if (data.loading) {
    return <LoadingIndicator />;
  }

  // We don't have any segments yet
  if (!data.routes || data.routes.length === 0) {
    return <EmptyPanelState panelType={'route'} showLink />;
  }

  return (
    <Sorting
      text="sort by"
      queryValueKey="sort"
      queryOrderKey="order"
      options={[
        {
          label: 'tti',
          queryValue: 'tti',
          initialOrder: 'dsc',
          isDefault: true,
        },
        { label: 'speed', queryValue: 'speed', initialOrder: 'asc' },
      ]}
      location={location}
      historyReplace={historyReplace}
    >
      {({ sortValue, sortOrder }) =>
        <div>
          <ListLabels sortValue={sortValue} location="route" />
          <List>
            {sortRoutes(data.routes, sortValue, sortOrder).map(route => {
              const { id, status } = route;
              const isActive = currentHover && currentHover.id === id;

              return (
                <ListItem
                  status={status}
                  id={id}
                  key={id}
                  contentType="route"
                  isActive={isActive}
                  onClick={() => selectEntity({ id, type: 'route' })}
                  onMouseOver={() => enterEntity({ id, type: 'route' })}
                  onMouseOut={() => leaveEntity({ id, type: 'route' })}
                >
                  <RoutesListItem route={route} sortValue={sortValue} />
                </ListItem>
              );
            })}
          </List>
        </div>}
    </Sorting>
  );
}

Routes.propTypes = {
  data: shape({
    loading: bool.isRequired,
    routes: arrayOf(
      shape({
        id: string.required,
        status: string.required,
        segments: arrayOf(
          shape({
            id: string,
          })
        ),
      })
    ),
  }).isRequired,
  currentHover: shape({ id: string.isRequired }),
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  location: locationShape.isRequired,
  historyReplace: func.isRequired,
};

const mapStateToProps = ({ map }, ownProps) => ({
  currentHover: map.currentHover,
  ...ownProps,
});

const ConnectedRoutesWithData = compose(
  connect(mapStateToProps, { ...operations, historyReplace: replace }),
  graphql(RoutesQuery, {
    options: ({ params }) => ({
      variables: {
        id: params.id,
      },
    }),
  })
)(Routes);

export default ConnectedRoutesWithData;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/Routes/index.js